import {Action, ActionReducerMap} from '@ngrx/store';

import * as actionsUi from './qs-checks.actions.ui';
import {APP_RESET_ACTION} from '@orga-app/appstart/actions';
import {FunktionsbereichPruefplaene, FunktionsbereichRolle, Pruefantwort, PruefantwortDetail, Pruefaufgabe, PruefaufgabeAntwort, PruefaufgabeDetail, Pruefcheckliste, PruefchecklisteDetail, Pruefobjekt, PruefobjektDetail, Pruefplan, PruefplanDetail} from '../../../clients/qschecks';
import {
    GET_FUNKTIONSBEREICHE_PRUEFPLAENE_ADMIN,
    GET_FUNKTIONSBEREICHE_PRUEFPLAENE_ADMIN_ERFOLGREICH,
    GET_FUNKTIONSBEREICHE_PRUEFPLAENE_ADMIN_FEHLER,
    GET_PRUEFPLAN_ADMIN,
    GET_PRUEFPLAN_ADMIN_ERFOLGREICH,
    GET_PRUEFPLAN_ADMIN_FEHLER,
    GET_PRUEFPLAN_ANTWORT_ADMIN,
    GET_PRUEFPLAN_ANTWORT_ADMIN_ERFOLGREICH,
    GET_PRUEFPLAN_ANTWORT_ADMIN_FEHLER,
    GET_PRUEFPLAN_ANTWORTEN_ADMIN,
    GET_PRUEFPLAN_ANTWORTEN_ADMIN_ERFOLGREICH,
    GET_PRUEFPLAN_ANTWORTEN_ADMIN_FEHLER,
    GET_PRUEFPLAN_PRUEFAUFGABE_ADMIN,
    GET_PRUEFPLAN_PRUEFAUFGABE_ADMIN_ERFOLGREICH,
    GET_PRUEFPLAN_PRUEFAUFGABE_ADMIN_FEHLER,
    GET_PRUEFPLAN_PRUEFAUFGABEN_ADMIN,
    GET_PRUEFPLAN_PRUEFAUFGABEN_ADMIN_ERFOLGREICH,
    GET_PRUEFPLAN_PRUEFAUFGABEN_ADMIN_FEHLER,
    GET_PRUEFPLAN_PRUEFCHECKLISTE_ADMIN,
    GET_PRUEFPLAN_PRUEFCHECKLISTE_ADMIN_ERFOLGREICH,
    GET_PRUEFPLAN_PRUEFCHECKLISTE_ADMIN_FEHLER,
    GET_PRUEFPLAN_PRUEFCHECKLISTEN_ADMIN,
    GET_PRUEFPLAN_PRUEFCHECKLISTEN_ADMIN_ERFOLGREICH,
    GET_PRUEFPLAN_PRUEFCHECKLISTEN_ADMIN_FEHLER,
    GET_PRUEFPLAN_PRUEFOBJEKT_ADMIN,
    GET_PRUEFPLAN_PRUEFOBJEKT_ADMIN_ERFOLGREICH,
    GET_PRUEFPLAN_PRUEFOBJEKT_ADMIN_FEHLER,
    GET_PRUEFPLAN_PRUEFOBJEKTE_ADMIN,
    GET_PRUEFPLAN_PRUEFOBJEKTE_ADMIN_ERFOLGREICH,
    GET_PRUEFPLAN_PRUEFOBJEKTE_ADMIN_FEHLER,
    GET_PRUEFPLAN_ROLLEN_CONTROLLER_ADMIN,
    GET_PRUEFPLAN_ROLLEN_CONTROLLER_ADMIN_ERFOLGREICH,
    GET_PRUEFPLAN_ROLLEN_CONTROLLER_ADMIN_FEHLER,
    GET_PRUEFPLAN_ROLLEN_PRUEFER_ADMIN,
    GET_PRUEFPLAN_ROLLEN_PRUEFER_ADMIN_ERFOLGREICH,
    GET_PRUEFPLAN_ROLLEN_PRUEFER_ADMIN_FEHLER,
    GetFunktionsbereichePruefplaeneAdminErfolgreichAction,
    GetFunktionsbereichePruefplaeneAdminFehlerAction,
    GetPruefplanAdminErfolgreichAction,
    GetPruefplanAntwortAdminErfolgreichAction,
    GetPruefplanAntwortenAdminErfolgreichAction,
    GetPruefplanPruefaufgabeAdminErfolgreichAction,
    GetPruefplanPruefaufgabenAdminErfolgreichAction,
    GetPruefplanPruefchecklisteAdminErfolgreichAction,
    GetPruefplanPruefchecklistenAdminErfolgreichAction,
    GetPruefplanPruefobjektAdminErfolgreichAction,
    GetPruefplanPruefobjekteAdminErfolgreichAction,
    GetPruefplanRollenControllerAdminErfolgreichAction,
    GetPruefplanRollenPrueferAdminErfolgreichAction,
    POST_PRUEFAUFGABE_ENTFERNEN_ERFOLGREICH,
    POST_PRUEFCHECKLISTE_ENTFERNEN_ERFOLGREICH,
    POST_PRUEFCHECKLISTE_HINZUFUEGEN,
    POST_PRUEFOBJEKT_ENTFERNEN_ERFOLGREICH,
    POST_PRUEFPLAN_ENTFERNEN_ERFOLGREICH, POST_PRUEFPLAN_HINZUFUEGEN_ERFOLGREICH,
    POST_PRUEFPLAN_ROLLE_CONTROLLER_ENTFERNEN,
    POST_PRUEFPLAN_ROLLEN_PRUEFER_ENTFERNEN_ERFOLGREICH,
    PostPruefchecklisteHinzufuegenAction, PostPruefplanHinzufuegenErfolgreichAction
} from '../../../client-ngrx/qschecks';
import {
    AKTUELLE_PRUEF_AUFGABE_SETZEN,
    AKTUELLE_PRUEF_CHECKLISTE_SETZEN,
    AKTUELLE_PRUEFPLAN_ANTWORT_SETZEN,
    AKTUELLEN_PRUEFPLAN_SETZEN,
    AktuellenPruefplanSetzenAction,
    AktuellePruefAufgabeSetzenAction,
    AktuellePruefChecklisteSetzenAction,
    AktuellePruefplanAntwortSetzenAction,
    AKTUELLES_PRUEFOBJEKT_SETZEN,
    AktuellesPruefobjektSetzenAction,
    NEUE_PRUEF_AUFGABE,
    NEUE_PRUEF_CHECKLISTE,
    NeuePruefAufgabeAction,
    NeuePruefChecklisteAction,
    NEUER_PRUEFPLAN,
    NeuerPruefplanAction,
    NEUES_PRUEFOBJEKT,
    NeuesPruefobjektAction, PRUEF_AUFGABE_ANTWORT_IST_AKTIV_SETZEN,
    PRUEF_AUFGABE_BESCHREIBUNG_SETZEN,
    PRUEF_AUFGABE_GEWICHTUNG_SETZEN,
    PRUEF_AUFGABE_IST_AKTIV_SETZEN,
    PRUEF_AUFGABE_TITEL_SETZEN,
    PRUEF_CHECKLISTE_BESCHREIBUNG_SETZEN,
    PRUEF_CHECKLISTE_IST_AKTIV_SETZEN,
    PRUEF_CHECKLISTE_TITEL_SETZEN, PruefAufgabeAntwortIstAktivSetzenAction,
    PruefAufgabeBeschreibungSetzenAction,
    PruefAufgabeGewichtungSetzenAction,
    PruefAufgabeIstAktivSetzenAction,
    PruefAufgabeTitelSetzenAction,
    PruefChecklisteBeschreibungSetzenAction,
    PruefChecklisteIstAktivSetzenAction,
    PruefChecklisteTitelSetzenAction,
    PRUEFOBJEKT_BESCHREIBUNG_SETZEN,
    PRUEFOBJEKT_IST_AKTIV_SETZEN,
    PRUEFOBJEKT_TITEL_SETZEN,
    PruefobjektBeschreibungSetzenAction,
    PruefobjektIstAktivSetzenAction,
    PruefobjektTitelSetzenAction,
    PRUEFPLAN_ANTWORT_BESCHREIBUNG_SETZEN, PRUEFPLAN_ANTWORT_FARBE_SETZEN,
    PRUEFPLAN_ANTWORT_GEWICHTUNG_SETZEN,
    PRUEFPLAN_ANTWORT_ICON_SETZEN,
    PRUEFPLAN_ANTWORT_IST_AKTIV_SETZEN,
    PRUEFPLAN_ANTWORT_IST_NA_ANTWORT_SETZEN,
    PRUEFPLAN_ANTWORT_KUERZEL_SETZEN,
    PRUEFPLAN_BESCHREIBUNG_SETZEN,
    PRUEFPLAN_IST_AKTIV_SETZEN,
    PRUEFPLAN_TITEL_SETZEN, PRUEFPLAN_ZAEHLER_PRO_V_TYP_SETZEN,
    PruefplanAntwortBeschreibungSetzenAction, PruefplanAntwortFarbeSetzenAction,
    PruefplanAntwortGewichtungSetzenAction,
    PruefplanAntwortIconSetzenAction,
    PruefplanAntwortIstAktivSetzenAction,
    PruefplanAntwortIstNaAntwortSetzenAction,
    PruefplanAntwortKuerzelSetzenAction,
    PruefplanBeschreibungSetzenAction,
    PruefplanIstAktivSetzenAction,
    PruefplanTitelSetzenAction, PruefplanZahlerProVTypSetzenAction,
    QS_CONTROLLER_ROLLEN_SETZEN,
    QS_PRUEFER_ROLLEN_SETZEN,
    QsControllerRollenSetzenAction,
    QsPrueferRollenSetzenAction
} from './qs-checks.actions.ui';


export interface ModuleState {
    page: PageState;
}


export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};


export interface PageState {
    // Prüfpläne
    pruefplaeneListe: Array<FunktionsbereichPruefplaene>;
    pruefplaeneListeLaden: boolean;
    pruefplaeneListeFehler: boolean;
    pruefplanSelektiert: Pruefplan;
    pruefplanAktuell: PruefplanDetail;
    pruefplanAktuellLaden: boolean;
    pruefplanAktuellFehler: boolean;

    pruefplanAntwortenListe: Array<Pruefantwort>;
    pruefplanAntwortenListeLaden: boolean;
    pruefplanAntwortenListeFehler: boolean;
    pruefplanAntwortSelektiert: Pruefantwort;
    pruefplanAntwortAktuell: PruefantwortDetail;
    pruefplanAntwortAktuellLaden: boolean;
    pruefplanAntwortAktuellFehler: boolean;

    // Prüfobjekte
    pruefobjekteListe: Array<Pruefobjekt>;
    pruefobjekteListeLaden: boolean;
    pruefobjekteListeFehler: boolean;
    pruefobjektSelektiert: Pruefobjekt;
    pruefobjektAktuell: PruefobjektDetail;
    pruefobjektAktuellLaden: boolean;
    pruefobjektAktuellFehler: boolean;

    // Prüf-Checklisten
    pruefChecklistenListe: Array<Pruefcheckliste>;
    pruefChecklistenListeLaden: boolean;
    pruefChecklistenListeFehler: boolean;
    pruefChecklisteSelektiert: Pruefcheckliste;
    pruefChecklisteAktuell: PruefchecklisteDetail;
    pruefChecklisteAktuellLaden: boolean;
    pruefChecklisteAktuellFehler: boolean;

    // Prüf-Aufgaben
    pruefAufgabenListe: Array<Pruefaufgabe>;
    pruefAufgabenListeLaden: boolean;
    pruefAufgabenListeFehler: boolean;
    pruefAufgabeSelektiert: Pruefaufgabe;
    pruefAufgabeAktuell: PruefaufgabeDetail;
    pruefAufgabeAktuellLaden: boolean;
    pruefAufgabeAktuellFehler: boolean;

    // Rollen/Berechtigungen
    qsPrueferRollen: Array<FunktionsbereichRolle>;
    qsPrueferRollenLaden: boolean;
    qsPrueferRollenFehler: boolean;
    qsPrueferRollenSelected: Array<string>;

    qsControllerRollen: Array<FunktionsbereichRolle>;
    qsControllerRollenLaden: boolean;
    qsControllerRollenFehler: boolean;
    qsControllerRollenSelected: Array<string>;
}

export const initialPageState: PageState = {
    // Prüfpläne
    pruefplaeneListe: null,
    pruefplaeneListeLaden: false,
    pruefplaeneListeFehler: false,
    pruefplanSelektiert: null,
    pruefplanAktuell: null,
    pruefplanAktuellLaden: false,
    pruefplanAktuellFehler: false,

    pruefplanAntwortenListe: null,
    pruefplanAntwortenListeLaden: false,
    pruefplanAntwortenListeFehler: false,
    pruefplanAntwortSelektiert: null,
    pruefplanAntwortAktuell: null,
    pruefplanAntwortAktuellLaden: false,
    pruefplanAntwortAktuellFehler: false,

    // Prüfobjekte
    pruefobjekteListe: null,
    pruefobjekteListeLaden: false,
    pruefobjekteListeFehler: false,
    pruefobjektSelektiert: null,
    pruefobjektAktuell: null,
    pruefobjektAktuellLaden: false,
    pruefobjektAktuellFehler: false,

    // Prüf-Checklisten
    pruefChecklistenListe: null,
    pruefChecklistenListeLaden: false,
    pruefChecklistenListeFehler: false,
    pruefChecklisteSelektiert: null,
    pruefChecklisteAktuell: null,
    pruefChecklisteAktuellLaden: false,
    pruefChecklisteAktuellFehler: false,

    // Prüf-Aufgaben
    pruefAufgabenListe: null,
    pruefAufgabenListeLaden: false,
    pruefAufgabenListeFehler: false,
    pruefAufgabeSelektiert: null,
    pruefAufgabeAktuell: null,
    pruefAufgabeAktuellLaden: false,
    pruefAufgabeAktuellFehler: false,

    // Rollen/Berechtigungen
    qsPrueferRollen: null,
    qsPrueferRollenLaden: false,
    qsPrueferRollenFehler: false,
    qsPrueferRollenSelected: [],

    qsControllerRollen: null,
    qsControllerRollenLaden: false,
    qsControllerRollenFehler: false,
    qsControllerRollenSelected: []
};

export function pageReducer(state = initialPageState, action: Action): PageState {

    switch (action.type) {

        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            return Object.assign({}, state, <PageState>initialPageState);
        }


        /* Prüfplaene */
        case GET_FUNKTIONSBEREICHE_PRUEFPLAENE_ADMIN: {
            return Object.assign({}, state, <PageState>{
                pruefplaeneListeLaden: true,
                pruefplaeneListeFehler: false
            });
        }

        case GET_FUNKTIONSBEREICHE_PRUEFPLAENE_ADMIN_ERFOLGREICH: {
            const a = <GetFunktionsbereichePruefplaeneAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                pruefplaeneListe: a.payload,
                pruefplaeneListeLaden: false,
                pruefplaeneListeFehler: false,
            });
        }

        case GET_FUNKTIONSBEREICHE_PRUEFPLAENE_ADMIN_FEHLER: {
            const a = <GetFunktionsbereichePruefplaeneAdminFehlerAction>action;

            return Object.assign({}, state, <PageState>{
                pruefplaeneListe: [],
                pruefplaeneListeLaden: false,
                pruefplaeneListeFehler: true,
            });
        }

        case AKTUELLE_PRUEFPLAN_ANTWORT_SETZEN: {
            const a = <AktuellePruefplanAntwortSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                pruefplanAntwortSelektiert: a.payload
            });
        }

        // Todo: speichern erfolgreich einbauen bei neu

        case GET_PRUEFPLAN_ANTWORT_ADMIN: {
            return Object.assign({}, state, <PageState>{
                pruefplanAntwortAktuellLaden: true,
                pruefplanAntwortAktuellFehler: false
            });
        }

        case GET_PRUEFPLAN_ANTWORT_ADMIN_ERFOLGREICH: {
            const a = <GetPruefplanAntwortAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                pruefplanAntwortAktuell: a.payload,
                pruefplanAntwortAktuellLaden: false,
                pruefplanAntwortAktuellFehler: false
            });
        }

        case GET_PRUEFPLAN_ANTWORT_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                pruefplanAntwortAktuell: null,
                pruefplanAntwortAktuellLaden: false,
                pruefplanAntwortAktuellFehler: true
            });
        }

        case PRUEFPLAN_ANTWORT_KUERZEL_SETZEN: {
            const a = <PruefplanAntwortKuerzelSetzenAction>action;

            const pruefplanAntwortAktuell = Object.assign({}, state.pruefplanAntwortAktuell, <PruefantwortDetail> {
                kuerzel: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefplanAntwortAktuell
            });
        }

        case PRUEFPLAN_ANTWORT_BESCHREIBUNG_SETZEN: {
            const a = <PruefplanAntwortBeschreibungSetzenAction>action;

            const pruefplanAntwortAktuell = Object.assign({}, state.pruefplanAntwortAktuell, <PruefantwortDetail> {
                beschreibung: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefplanAntwortAktuell
            });
        }

        case PRUEFPLAN_ANTWORT_GEWICHTUNG_SETZEN: {
            const a = <PruefplanAntwortGewichtungSetzenAction>action;

            const pruefplanAntwortAktuell = Object.assign({}, state.pruefplanAntwortAktuell, <PruefantwortDetail> {
                gewichtung: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefplanAntwortAktuell
            });
        }

        case PRUEFPLAN_ANTWORT_FARBE_SETZEN: {
            const a = <PruefplanAntwortFarbeSetzenAction>action;

            const pruefplanAntwortAktuell = Object.assign({}, state.pruefplanAntwortAktuell, <PruefantwortDetail> {
                farbe: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefplanAntwortAktuell
            });
        }

        case PRUEFPLAN_ANTWORT_ICON_SETZEN: {
            const a = <PruefplanAntwortIconSetzenAction>action;

            const pruefplanAntwortAktuell = Object.assign({}, state.pruefplanAntwortAktuell, <PruefantwortDetail> {
                icon: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefplanAntwortAktuell
            });
        }

        case PRUEFPLAN_ANTWORT_IST_AKTIV_SETZEN: {
            const a = <PruefplanAntwortIstAktivSetzenAction>action;

            const pruefplanAntwortAktuell = Object.assign({}, state.pruefplanAntwortAktuell, <PruefantwortDetail> {
                ist_aktiv: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefplanAntwortAktuell
            });
        }

        case PRUEFPLAN_ANTWORT_IST_NA_ANTWORT_SETZEN: {
            const a = <PruefplanAntwortIstNaAntwortSetzenAction>action;

            const pruefplanAntwortAktuell = Object.assign({}, state.pruefplanAntwortAktuell, <PruefantwortDetail> {
                ist_na: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefplanAntwortAktuell
            });
        }

        /* Prüfplan Antworten */
        case GET_PRUEFPLAN_ANTWORTEN_ADMIN: {
            return Object.assign({}, state, <PageState>{
                pruefplanAntwortenListeLaden: true,
                pruefplanAntwortenListeFehler: false
            });
        }

        case GET_PRUEFPLAN_ANTWORTEN_ADMIN_ERFOLGREICH: {
            const a = <GetPruefplanAntwortenAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                pruefplanAntwortenListe: a.payload,
                pruefplanAntwortenListeLaden: false,
                pruefplanAntwortenListeFehler: false
            });
        }

        case GET_PRUEFPLAN_ANTWORTEN_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                pruefplanAntwortenListe: [],
                pruefplanAntwortenListeLaden: false,
                pruefplanAntwortenListeFehler: true
            });
        }

        case AKTUELLEN_PRUEFPLAN_SETZEN: {
            const a = <AktuellenPruefplanSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                pruefplanSelektiert: a.payload,
                pruefplanAntwortSelektiert: null,
                pruefplanAntwortAktuell: null,
                pruefobjektSelektiert: null,
                pruefobjektAktuell: null,
                pruefChecklisteSelektiert: null,
                pruefChecklisteAktuell: null,
                pruefAufgabeSelektiert: null,
                pruefAufgabeAktuell: null,
                qsPrueferRollenSelected: [],
                qsControllerRollenSelected: []
            });
        }

        // Todo: speichern erfolgreich einbauen bei neu

        case GET_PRUEFPLAN_ADMIN: {
            return Object.assign({}, state, <PageState>{
                pruefplanAktuellLaden: true,
                pruefplanAktuellFehler: false
            });
        }

        case GET_PRUEFPLAN_ADMIN_ERFOLGREICH: {
            const a = <GetPruefplanAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                pruefplanAktuell: a.payload,
                pruefplanAktuellLaden: false,
                pruefplanAktuellFehler: false
            });
        }

        case GET_PRUEFPLAN_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                pruefplanAktuell: null,
                pruefplanAktuellLaden: false,
                pruefplanAktuellFehler: true
            });
        }

        case NEUER_PRUEFPLAN: {
            const a = <NeuerPruefplanAction>action;

            const pruefplan: PruefplanDetail = {
                funktionsbereich_id: a.payload,
                ist_aktiv: true
            };

            return Object.assign({}, state, <PageState>{
                pruefplanAktuell: pruefplan
            });
        }

        case POST_PRUEFPLAN_ENTFERNEN_ERFOLGREICH: {
            return Object.assign({}, state, <PageState>{
                pruefplanSelektiert: null,
                pruefplanAktuell: null
            });
        }

        case POST_PRUEFPLAN_HINZUFUEGEN_ERFOLGREICH: {
            const a = <PostPruefplanHinzufuegenErfolgreichAction>action;

            if (a.pruefplanModelRequest.titel === state.pruefplanAktuell.titel) {
                return Object.assign({}, state, <PageState>{
                    pruefplanSelektiert: Object.assign({}, state.pruefplanSelektiert, <Pruefplan>{
                        pruefplan_id: a.pruefplanModelRequest.pruefplan_id
                    }),
                    pruefplanAktuell: Object.assign({}, state.pruefplanAktuell, <Pruefplan>{
                        pruefplan_id: a.pruefplanModelRequest.pruefplan_id
                    })
                });
            } else {
                return state;
            }
        }

        case PRUEFPLAN_TITEL_SETZEN: {
            const a = <PruefplanTitelSetzenAction>action;

            const pruefplanAktuell = Object.assign({}, state.pruefplanAktuell, <PruefplanDetail> {
                titel: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefplanAktuell
            });
        }

        case PRUEFPLAN_BESCHREIBUNG_SETZEN: {
            const a = <PruefplanBeschreibungSetzenAction>action;

            const pruefplanAktuell = Object.assign({}, state.pruefplanAktuell, <PruefplanDetail> {
                beschreibung: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefplanAktuell
            });
        }

        case PRUEFPLAN_IST_AKTIV_SETZEN: {
            const a = <PruefplanIstAktivSetzenAction>action;

            const pruefplanAktuell = Object.assign({}, state.pruefplanAktuell, <PruefplanDetail> {
                ist_aktiv: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefplanAktuell
            });
        }

        case PRUEFPLAN_ZAEHLER_PRO_V_TYP_SETZEN: {
            const a = <PruefplanZahlerProVTypSetzenAction>action;

            const pruefplanAktuell = Object.assign({}, state.pruefplanAktuell, <PruefplanDetail> {
                zaehler_pro_veranstaltungstyp: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefplanAktuell
            });
        }

        /* Pruefobjekte */
        case GET_PRUEFPLAN_PRUEFOBJEKTE_ADMIN: {
            return Object.assign({}, state, <PageState>{
                pruefobjekteListeLaden: true,
                pruefobjekteListeFehler: false
            });
        }

        case GET_PRUEFPLAN_PRUEFOBJEKTE_ADMIN_ERFOLGREICH: {
            const a = <GetPruefplanPruefobjekteAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                pruefobjekteListe: a.payload,
                pruefobjekteListeLaden: false,
                pruefobjekteListeFehler: false,
            });
        }

        case GET_PRUEFPLAN_PRUEFOBJEKTE_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                pruefobjekteListe: [],
                pruefobjekteListeLaden: false,
                pruefobjekteListeFehler: true,
            });
        }

        case AKTUELLES_PRUEFOBJEKT_SETZEN: {
            const a = <AktuellesPruefobjektSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                pruefobjektSelektiert: a.payload
            });
        }

        // Todo: speichern erfolgreich einbauen bei neu

        case GET_PRUEFPLAN_PRUEFOBJEKT_ADMIN: {
            return Object.assign({}, state, <PageState>{
                pruefobjektAktuellLaden: true,
                pruefobjektAktuellFehler: false
            });
        }

        case GET_PRUEFPLAN_PRUEFOBJEKT_ADMIN_ERFOLGREICH: {
            const a = <GetPruefplanPruefobjektAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                pruefobjektAktuell: a.payload,
                pruefobjektAktuellLaden: false,
                pruefobjektAktuellFehler: false
            });
        }

        case GET_PRUEFPLAN_PRUEFOBJEKT_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                pruefobjektAktuell: null,
                pruefobjektAktuellLaden: false,
                pruefobjektAktuellFehler: true
            });
        }

        case NEUES_PRUEFOBJEKT: {
            const a = <NeuesPruefobjektAction>action;

            const pruefobjekt: PruefobjektDetail = {
                pruefplan_id: state.pruefplanSelektiert.pruefplan_id,
                ist_aktiv: true
            };

            return Object.assign({}, state, <PageState>{
                pruefobjektAktuell: pruefobjekt,
                pruefobjektSelektiert: null
            });
        }

        case POST_PRUEFOBJEKT_ENTFERNEN_ERFOLGREICH: {
            return Object.assign({}, state, <PageState>{
                pruefobjektSelektiert: null,
                pruefobjektAktuell: null
            });
        }

        case PRUEFOBJEKT_TITEL_SETZEN: {
            const a = <PruefobjektTitelSetzenAction>action;

            const pruefobjektAktuell = Object.assign({}, state.pruefobjektAktuell, <PruefobjektDetail> {
                titel: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefobjektAktuell
            });
        }

        case PRUEFOBJEKT_BESCHREIBUNG_SETZEN: {
            const a = <PruefobjektBeschreibungSetzenAction>action;

            const pruefobjektAktuell = Object.assign({}, state.pruefobjektAktuell, <PruefobjektDetail> {
                beschreibung: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefobjektAktuell
            });
        }

        case PRUEFOBJEKT_IST_AKTIV_SETZEN: {
            const a = <PruefobjektIstAktivSetzenAction>action;

            const pruefobjektAktuell = Object.assign({}, state.pruefobjektAktuell, <PruefobjektDetail> {
                ist_aktiv: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefobjektAktuell
            });
        }

        /* Prüf-Checklisten */
        case GET_PRUEFPLAN_PRUEFCHECKLISTEN_ADMIN: {
            return Object.assign({}, state, <PageState>{
                pruefChecklistenListeLaden: true,
                pruefChecklistenListeFehler: false
            });
        }

        case GET_PRUEFPLAN_PRUEFCHECKLISTEN_ADMIN_ERFOLGREICH: {
            const a = <GetPruefplanPruefchecklistenAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                pruefChecklistenListe: a.payload,
                pruefChecklistenListeLaden: false,
                pruefChecklistenListeFehler: false,
            });
        }

        case GET_PRUEFPLAN_PRUEFCHECKLISTEN_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                pruefChecklistenListe: [],
                pruefChecklistenListeLaden: false,
                pruefChecklistenListeFehler: true,
            });
        }

        case AKTUELLE_PRUEF_CHECKLISTE_SETZEN: {
            const a = <AktuellePruefChecklisteSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                pruefChecklisteSelektiert: a.payload,
                pruefAufgabeSelektiert: null,
                pruefAufgabeAktuell: null
            });
        }

        case POST_PRUEFCHECKLISTE_HINZUFUEGEN: {
            const a = <PostPruefchecklisteHinzufuegenAction>action;

            return Object.assign({}, state, <PageState>{
                pruefChecklisteSelektiert: {
                    pruefplan_id: a.pruefchecklisteModelRequest.pruefplan_id,
                    titel: a.pruefchecklisteModelRequest.titel,
                    ist_aktiv: a.pruefchecklisteModelRequest.ist_aktiv,
                    pruefcheckliste_id: a.pruefchecklisteModelRequest.pruefcheckliste_id
                }
            });
        }

        case GET_PRUEFPLAN_PRUEFCHECKLISTE_ADMIN: {
            return Object.assign({}, state, <PageState>{
                pruefChecklisteAktuellLaden: true,
                pruefChecklisteAktuellFehler: false
            });
        }

        case GET_PRUEFPLAN_PRUEFCHECKLISTE_ADMIN_ERFOLGREICH: {
            const a = <GetPruefplanPruefchecklisteAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                pruefChecklisteAktuell: a.payload,
                pruefChecklisteAktuellLaden: false,
                pruefChecklisteAktuellFehler: false
            });
        }

        case GET_PRUEFPLAN_PRUEFCHECKLISTE_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                pruefChecklisteAktuell: null,
                pruefChecklisteAktuellLaden: false,
                pruefChecklisteAktuellFehler: true
            });
        }

        case NEUE_PRUEF_CHECKLISTE: {
            const a = <NeuePruefChecklisteAction>action;

            const pruefChecklisteAktuell: PruefchecklisteDetail = {
                pruefplan_id: state.pruefplanSelektiert.pruefplan_id,
                ist_aktiv: true
            };

            return Object.assign({}, state, <PageState>{
                pruefChecklisteAktuell,
                pruefChecklisteSelektiert: null,
                pruefAufgabenListe: null,
                pruefAufgabeAktuell: null,
                pruefAufgabeSelektiert: null
            });
        }

        case POST_PRUEFCHECKLISTE_ENTFERNEN_ERFOLGREICH: {
            return Object.assign({}, state, <PageState>{
                pruefChecklisteSelektiert: null,
                pruefChecklisteAktuell: null
            });
        }

        case PRUEF_CHECKLISTE_TITEL_SETZEN: {
            const a = <PruefChecklisteTitelSetzenAction>action;

            const pruefChecklisteAktuell = Object.assign({}, state.pruefChecklisteAktuell, <PruefchecklisteDetail> {
                titel: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefChecklisteAktuell
            });
        }

        case PRUEF_CHECKLISTE_BESCHREIBUNG_SETZEN: {
            const a = <PruefChecklisteBeschreibungSetzenAction>action;

            const pruefChecklisteAktuell = Object.assign({}, state.pruefChecklisteAktuell, <PruefchecklisteDetail> {
                beschreibung: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefChecklisteAktuell
            });
        }

        case PRUEF_CHECKLISTE_IST_AKTIV_SETZEN: {
            const a = <PruefChecklisteIstAktivSetzenAction>action;

            const pruefChecklisteAktuell = Object.assign({}, state.pruefChecklisteAktuell, <PruefchecklisteDetail> {
                ist_aktiv: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefChecklisteAktuell
            });
        }

        /* Prüf-Aufgaben */
        case GET_PRUEFPLAN_PRUEFAUFGABEN_ADMIN: {
            return Object.assign({}, state, <PageState>{
                pruefAufgabenListeLaden: true,
                pruefAufgabenListeFehler: false
            });
        }

        case GET_PRUEFPLAN_PRUEFAUFGABEN_ADMIN_ERFOLGREICH: {
            const a = <GetPruefplanPruefaufgabenAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                pruefAufgabenListe: a.payload,
                pruefAufgabenListeLaden: false,
                pruefAufgabenListeFehler: false
            });
        }

        case GET_PRUEFPLAN_PRUEFAUFGABEN_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                pruefAufgabenListe: [],
                pruefAufgabenListeLaden: false,
                pruefAufgabenListeFehler: true
            });
        }

        case AKTUELLE_PRUEF_AUFGABE_SETZEN: {
            const a = <AktuellePruefAufgabeSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                pruefAufgabeSelektiert: a.payload
            });
        }

        // Todo: speichern erfolgreich einbauen bei neu

        case GET_PRUEFPLAN_PRUEFAUFGABE_ADMIN: {
            return Object.assign({}, state, <PageState>{
                pruefAufgabeAktuellLaden: true,
                pruefAufgabeAktuellFehler: false
            });
        }

        case GET_PRUEFPLAN_PRUEFAUFGABE_ADMIN_ERFOLGREICH: {
            const a = <GetPruefplanPruefaufgabeAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                pruefAufgabeAktuell: a.payload,
                pruefAufgabeAktuellLaden: false,
                pruefAufgabeAktuellFehler: false
            });
        }

        case GET_PRUEFPLAN_PRUEFAUFGABE_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                pruefAufgabeAktuell: null,
                pruefAufgabeAktuellLaden: false,
                pruefAufgabeAktuellFehler: true
            });
        }

        case NEUE_PRUEF_AUFGABE: {
            const a = <NeuePruefAufgabeAction>action;

            const pruefAufgabeAktuell: PruefaufgabeDetail = {
                pruefplan_id: state.pruefChecklisteAktuell.pruefplan_id,
                pruefcheckliste_id: state.pruefChecklisteAktuell.pruefcheckliste_id,
                ist_aktiv: true
            };

            return Object.assign({}, state, <PageState>{
                pruefAufgabeAktuell
            });
        }

        case POST_PRUEFAUFGABE_ENTFERNEN_ERFOLGREICH: {
            return Object.assign({}, state, <PageState>{
                pruefAufgabeSelektiert: null,
                pruefAufgabeAktuell: null
            });
        }

        case PRUEF_AUFGABE_TITEL_SETZEN: {
            const a = <PruefAufgabeTitelSetzenAction>action;

            const pruefAufgabeAktuell = Object.assign({}, state.pruefAufgabeAktuell, <PruefaufgabeDetail> {
                titel: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefAufgabeAktuell
            });
        }

        case PRUEF_AUFGABE_BESCHREIBUNG_SETZEN: {
            const a = <PruefAufgabeBeschreibungSetzenAction>action;

            const pruefAufgabeAktuell = Object.assign({}, state.pruefAufgabeAktuell, <PruefaufgabeDetail> {
                beschreibung: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefAufgabeAktuell
            });
        }

        case PRUEF_AUFGABE_GEWICHTUNG_SETZEN: {
            const a = <PruefAufgabeGewichtungSetzenAction>action;

            const pruefAufgabeAktuell = Object.assign({}, state.pruefAufgabeAktuell, <PruefaufgabeDetail> {
                gewichtung: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefAufgabeAktuell
            });
        }

        case PRUEF_AUFGABE_IST_AKTIV_SETZEN: {
            const a = <PruefAufgabeIstAktivSetzenAction>action;

            const pruefAufgabeAktuell = Object.assign({}, state.pruefAufgabeAktuell, <PruefaufgabeDetail> {
                ist_aktiv: a.payload
            });

            return Object.assign({}, state, <PageState>{
                pruefAufgabeAktuell
            });
        }

        case PRUEF_AUFGABE_ANTWORT_IST_AKTIV_SETZEN: {
            const a = <PruefAufgabeAntwortIstAktivSetzenAction>action;

            const index = state.pruefAufgabeAktuell.zulaessige_antworten.findIndex(x => x.pruefantwort.antwort_id === a.pruefantwort.antwort_id);

            const zulaessige_antworten: Array<PruefaufgabeAntwort> = Object.assign([], state.pruefAufgabeAktuell.zulaessige_antworten);

            if (index > -1) {
                const antwort = zulaessige_antworten[index];
                zulaessige_antworten[index] = {ist_aktiv: a.payload, pruefantwort: a.pruefantwort};
            }

            const pruefAufgabeAktuell = Object.assign({}, state.pruefAufgabeAktuell, <PruefaufgabeDetail> {
                zulaessige_antworten
            });

            return Object.assign({}, state, <PageState>{
                pruefAufgabeAktuell
            });
        }



        /* QS-Prüfer-ROLLEN */
        case GET_PRUEFPLAN_ROLLEN_PRUEFER_ADMIN: {
            return Object.assign({}, state, <PageState>{
                qsPrueferRollenLaden: true,
                qsPrueferRollenFehler: false
            });
        }

        case GET_PRUEFPLAN_ROLLEN_PRUEFER_ADMIN_ERFOLGREICH: {
            const a = <GetPruefplanRollenPrueferAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                qsPrueferRollen: a.payload,
                qsPrueferRollenLaden: false,
                qsPrueferRollenFehler: false
            });
        }

        case GET_PRUEFPLAN_ROLLEN_PRUEFER_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                qsPrueferRollen: null,
                qsPrueferRollenLaden: false,
                qsPrueferRollenFehler: true
            });
        }

        case QS_PRUEFER_ROLLEN_SETZEN: {
            const a = <QsPrueferRollenSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                qsPrueferRollenSelected: a.payload
            });
        }

        case POST_PRUEFPLAN_ROLLEN_PRUEFER_ENTFERNEN_ERFOLGREICH: {
            return Object.assign({}, state, <PageState>{
                qsPrueferRollenSelected: []
            });
        }

        /* QS-Controller-ROLLEN */
        case GET_PRUEFPLAN_ROLLEN_CONTROLLER_ADMIN: {
            return Object.assign({}, state, <PageState>{
                qsControllerRollenLaden: true,
                qsControllerRollenFehler: false
            });
        }

        case GET_PRUEFPLAN_ROLLEN_CONTROLLER_ADMIN_ERFOLGREICH: {
            const a = <GetPruefplanRollenControllerAdminErfolgreichAction>action;

            return Object.assign({}, state, <PageState>{
                qsControllerRollen: a.payload,
                qsControllerRollenLaden: false,
                qsControllerRollenFehler: false
            });
        }

        case GET_PRUEFPLAN_ROLLEN_CONTROLLER_ADMIN_FEHLER: {
            return Object.assign({}, state, <PageState>{
                qsControllerRollen: null,
                qsControllerRollenLaden: false,
                qsControllerRollenFehler: true
            });
        }

        case QS_CONTROLLER_ROLLEN_SETZEN: {
            const a = <QsControllerRollenSetzenAction>action;

            return Object.assign({}, state, <PageState>{
                qsControllerRollenSelected: a.payload
            });
        }

        case POST_PRUEFPLAN_ROLLE_CONTROLLER_ENTFERNEN: {
            return Object.assign({}, state, <PageState>{
                qsControllerRollenSelected: []
            });
        }

        default: {
            return state;
        }
    }
}
